import script from "./FavoriteResourceCard.vue?vue&type=script&setup=true&lang=js"
export * from "./FavoriteResourceCard.vue?vue&type=script&setup=true&lang=js"

import "./FavoriteResourceCard.vue?vue&type=style&index=0&id=e33ae068&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e33ae068"]])

export default __exports__